const getDocHeight = (el) => {
  return Math.max(
    el.body.scrollHeight, el.documentElement.scrollHeight,
    el.body.offsetHeight, el.documentElement.offsetHeight,
    el.body.clientHeight, el.documentElement.clientHeight
  )
}

const getCookie = (name) => {
  let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  if (match)
    return match[2]
  else
    return null
}


export  {
  getDocHeight,
  getCookie
}



